///////////////////////////////////////////////
//           Contdown Item styling           //
///////////////////////////////////////////////

:host {
  @apply inline-flex;
}

.countdown-item--container {
  font-family: var(--countdown--font-family);
}

.countdown-item--container__value {
  @apply bg-[color:--countdown-item--background-color];
  @apply rounded-m border-[color:--countdown-item--background-color];
  @apply text-[length:--countdown-item--font-size--time] text-[color:--countdown--color-number];
  @apply min-h-[--countdown-item--min-height] min-w-[--countdown-item--min-width];
  font-family: var(--countdown--font-family--bold);
}

.countdown-item--container__label {
  @apply text-[length:--countdown-item--font-size--label] text-[color:--countdown--color-label];
}
